import ReactDOM from "react-dom";

const ConfirmModal = ({
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  busy = false,
  danger = false,
  fitContent = false,
  centerActions = false,
}) => {
  return ReactDOM.createPortal(
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget && !busy) onCancel();
      }}
    >
      <div
        className="modal-box"
        style={{
          fontSize: "0.85em",
          ...(fitContent ? { width: "fit-content" } : {}),
        }}
      >
        <h3>{title}</h3>

        <div style={{ margin: "0 0 12px", color: "#555" }}>{message}</div>

        <div
          className="modal-actions"
          style={centerActions ? { justifyContent: "center" } : undefined}
        >
          <button onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            disabled={busy}
            style={
              danger
                ? {
                    backgroundColor: "#e67e22",
                    borderColor: "#e67e22",
                    color: "#fff",
                  }
                : undefined
            }
          >
            {busy ? "Working…" : danger ? "⚠ " + confirmLabel : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ConfirmModal;
